import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EParametersFormValues = {
	vendor: 'vendor',
	version: 'version',
	nodes: 'nodes',
	configType: 'configType',
	technology: 'technology',
	nodeType: 'nodeType',
	siteIds: 'siteIds',
	networkElements: 'networkElements',
	from: 'from',
	to: 'to',
} as const;

export type TParametersFormValues = TValueOfStringRecord<typeof EParametersFormValues>
